import React from 'react';

const PerformanceIndicator = ({ fetchedPropertyData, totalProperties }) => {
  // Calculate performance metrics
  const dataEntries = Object.values(fetchedPropertyData);
  const cachedCount = dataEntries.filter(entry => 
    entry.data?.fromCache || entry.data?.source?.includes('cached')
  ).length;
  const freshCount = dataEntries.filter(entry => 
    entry.status === 'success' && !entry.data?.fromCache && !entry.data?.source?.includes('cached')
  ).length;
  const loadingCount = dataEntries.filter(entry => 
    entry.status === 'loading' || entry.status === 'queued'
  ).length;
  const errorCount = dataEntries.filter(entry => 
    entry.status === 'error'
  ).length;

  const cacheHitRate = totalProperties > 0 ? ((cachedCount / totalProperties) * 100).toFixed(1) : 0;

  if (dataEntries.length === 0) return null;

  return (
    <div className="bg-gradient-to-r from-green-50 to-blue-50 border border-green-200 rounded-lg p-3 mb-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <div className="flex items-center">
            <div className="w-3 h-3 bg-green-500 rounded-full mr-2"></div>
            <span className="text-sm font-medium text-green-700">
              {cachedCount} Cached (Instant)
            </span>
          </div>
          
          <div className="flex items-center">
            <div className="w-3 h-3 bg-blue-500 rounded-full mr-2"></div>
            <span className="text-sm font-medium text-blue-700">
              {freshCount} Fresh API
            </span>
          </div>
          
          {loadingCount > 0 && (
            <div className="flex items-center">
              <div className="w-3 h-3 bg-yellow-500 rounded-full mr-2 animate-pulse"></div>
              <span className="text-sm font-medium text-yellow-700">
                {loadingCount} Loading
              </span>
            </div>
          )}
          
          {errorCount > 0 && (
            <div className="flex items-center">
              <div className="w-3 h-3 bg-red-500 rounded-full mr-2"></div>
              <span className="text-sm font-medium text-red-700">
                {errorCount} Failed
              </span>
            </div>
          )}
        </div>
        
        <div className="text-right">
          <div className="text-lg font-bold text-green-600">
            {cacheHitRate}% Cache Hit Rate
          </div>
          <div className="text-xs text-gray-500">
            {cachedCount > 0 ? 'Optimized for speed!' : 'Building cache...'}
          </div>
        </div>
      </div>
      
      {/* Progress bar */}
      <div className="mt-2 w-full bg-gray-200 rounded-full h-2">
        <div className="flex h-2 rounded-full overflow-hidden">
          {cachedCount > 0 && (
            <div 
              className="bg-green-500" 
              style={{ width: `${(cachedCount / totalProperties) * 100}%` }}
            ></div>
          )}
          {freshCount > 0 && (
            <div 
              className="bg-blue-500" 
              style={{ width: `${(freshCount / totalProperties) * 100}%` }}
            ></div>
          )}
          {loadingCount > 0 && (
            <div 
              className="bg-yellow-500 animate-pulse" 
              style={{ width: `${(loadingCount / totalProperties) * 100}%` }}
            ></div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PerformanceIndicator; 